import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  // Set item (string only)
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Get item (string only)
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Remove item
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items
  clear(): void {
    localStorage.clear();
  }
}

